module.exports = __webpack_public_path__ + "img/insta1.44767a14.jpg";